package ui.composables

import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.font.FontFamily
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.sp
import org.jetbrains.compose.resources.Font
import thewedding_cmp.composeapp.generated.resources.AlexBrush_Regular
import thewedding_cmp.composeapp.generated.resources.Res

@Composable
fun WonderTitleText(
    modifier: Modifier = Modifier,
    style: TextStyle = MaterialTheme.typography.titleLarge,
    font: FontFamily = FontFamily(Font(Res.font.AlexBrush_Regular)),
) {
    val spanStyle = style.copy(
        fontFamily = font,
        fontWeight = FontWeight.Normal,
        color = Color(0xff323232),
        fontSize = 68.sp,
    )

    val title = "\u200EEva\u200E\n\u200E& Danu\u200E"
    Text(
        title,
        modifier = modifier,
        style = spanStyle,
        textAlign = TextAlign.Center
    )
}